import { render, staticRenderFns } from "./download.vue?vue&type=template&id=5714c405&"
import script from "./download.vue?vue&type=script&lang=js&"
export * from "./download.vue?vue&type=script&lang=js&"
import style0 from "./download.vue?vue&type=style&index=0&id=5714c405&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5714c405')) {
      api.createRecord('5714c405', component.options)
    } else {
      api.reload('5714c405', component.options)
    }
    module.hot.accept("./download.vue?vue&type=template&id=5714c405&", function () {
      api.rerender('5714c405', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/download/download.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/download/download.vue
// module id = pd/t
// module chunks = 0